export default "/images/642c53b61823474ccf58f76e0450851d.avif";